import React from 'react';
import { useIntl } from 'react-intl';
import { Box } from '@biome-design-system/ui/Box';
import type { SearchLink, SearchModification } from 'Src/types/search';
import type { GetUpdatedSearch } from 'Src/types/search';
import type { Log } from 'Src/types';
import { SearchChip, SearchChipSection } from './SearchChipSection';
import { searchCategoryDisplayDescriptor } from '../utils';
import { messages } from './messages';

const SUGGESTED_SEARCHES_HEADING_ID = 'noResultsSuggestedSearchesHeading';

interface SuggestedSearchesProps {
  baseQueryMods: SearchModification[];
  getUpdatedSearch: GetUpdatedSearch;
  log: Log;
  suggestions: SearchLink[];
}
export const SuggestedSearches = ({
  baseQueryMods,
  getUpdatedSearch,
  log,
  suggestions
}: SuggestedSearchesProps) => {
  const intl = useIntl();
  const handleClickSuggestion = (suggestion: SearchLink) => {
    log('user_action.search_results.spell_suggestion_clicked', {
      suggestion: suggestion.display_text,
      suggestion_type: suggestion.display_search_type
    });
  };
  return (
    <Box
      sx={(theme) => ({ marginBottom: theme.spacing(3) })}
      data-testid="noResults.suggestions"
    >
      <SearchChipSection
        heading={intl.formatMessage(messages.suggestedSearchesHeading)}
        headingId={SUGGESTED_SEARCHES_HEADING_ID}
      >
        {suggestions.map((suggestion) => {
          const categoryDescriptor = searchCategoryDisplayDescriptor(
            suggestion.display_search_type
          );
          const label = `${suggestion.display_text} (${intl.formatMessage(categoryDescriptor)})`;
          return (
            <SearchChip
              key={suggestion.display_text}
              label={label}
              onClick={() => handleClickSuggestion(suggestion)}
              queryModifications={[
                ...baseQueryMods,
                ...suggestion.query_modifications
              ]}
              getUpdatedSearch={getUpdatedSearch}
            />
          );
        })}
      </SearchChipSection>
    </Box>
  );
};
